import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";
import http from "../HttpService";
const apiEndpoint = API_BASE_URL_ENV() + "/admin/attendance";
const apiFingerprintEndpoint =
	API_BASE_URL_ENV() + "/admin/hr/fingerprint-settings";

export default class AttendanceService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	updateFingerprintSettings(id, data) {
		return http.patch(`${apiFingerprintEndpoint}/${id}`, data);
	}

	getFingerprintSettings(data) {
		return http.get(apiFingerprintEndpoint, data);
	}
}
